import { render, staticRenderFns } from "./RiChang4.vue?vue&type=template&id=05ee19d6&scoped=true&"
import script from "./RiChang4.vue?vue&type=script&lang=js&"
export * from "./RiChang4.vue?vue&type=script&lang=js&"
import style0 from "./RiChang4.vue?vue&type=style&index=0&id=05ee19d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ee19d6",
  null
  
)

export default component.exports